import { Stack } from '@mui/material';
import { type FlowOutputBlock } from 'flow-schema';

import { api, isDefined, isTruthy } from 'common';

import { FieldReferenceHelp } from './Help';
import { useReactFlowViewContext } from '../../../../../ReactFlow/context/context';
import { isOutputBlockType } from '../../../../../ReactFlow/types';
import { OutputCodeMirror, type OutputCodeMirrorProps } from '../CodeMirror';

type FieldReferenceCodeMirrorProps = Omit<OutputCodeMirrorProps, 'referenceRoot'>;

export function FieldReferenceCodeMirror(props: FieldReferenceCodeMirrorProps) {
  const { selectedNodeData } = useReactFlowViewContext();
  if (!isDefined(selectedNodeData)) {
    return <OutputCodeMirror {...props} />;
  }

  const blockName = isOutputBlockType(selectedNodeData.uiBlockType)
    ? (selectedNodeData.config as FlowOutputBlock['config']).data
    : selectedNodeData.label;

  if (!isTruthy(blockName)) {
    return <OutputCodeMirror {...props} />;
  }

  return (
    <Stack gap={1}>
      <FieldReferenceHelp />
      <OutputCodeMirror
        {...props}
        referenceRoot={`${blockName}.${api.FlowDefinition.FlowKeywords.data}`}
      />
    </Stack>
  );
}
